import { topicZones } from "../../../mocks/hotNews";
import SectionHeading from "./SectionHeading";

export default function TopicZones() {
  return (
    <section id="zones" className="w-full bg-background-100/60 py-14 md:py-20">
      <div className="mx-auto w-full max-w-[1320px] px-4 md:px-6">
        <SectionHeading
          eyebrow="主题专区"
          title="深度围观，一次看懂一场热闹"
          desc="把反复发酵的热闹按主题系统梳理成册，名场面、风向与反转连续剧，一篇带你回到前排第一视角。"
        />
        <div className="grid grid-cols-1 gap-6 lg:grid-cols-3">
          {topicZones.map((z) => (
            <a
              key={z.id}
              href="#subscribe"
              className="group relative flex min-h-[400px] flex-col justify-end overflow-hidden rounded-2xl p-6"
            >
              <img
                src={z.cover}
                alt={`主题专区：${z.title}`}
                title={`${z.title} - 看料门专题`}
                className="absolute inset-0 h-full w-full object-cover object-center transition-transform duration-500 group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/90 via-foreground-950/35 to-transparent"></div>
              <div className="relative">
                <div className="mb-3 flex items-center gap-2">
                  <span className="rounded-full bg-primary-500 px-3 py-1 text-xs font-medium text-background-50">
                    {z.label}
                  </span>
                </div>
                <h3 className="font-heading text-2xl leading-snug text-background-50">{z.title}</h3>
                <p className="mt-3 text-sm leading-relaxed text-foreground-200">{z.desc}</p>
                <div className="mt-5 flex items-center justify-between">
                  <span className="flex items-center gap-1.5 text-xs text-foreground-300">
                    <i className="ri-folder-line"></i> {z.stat}
                  </span>
                  <span className="flex items-center gap-1 whitespace-nowrap text-sm font-medium text-accent-400 group-hover:gap-2">
                    进入专区 <i className="ri-arrow-right-line"></i>
                  </span>
                </div>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}